import axiosClient from "utils/api";
const URI = "/drive/files";

export const getAllRootFiles = async (payload) => {
  const URL = `${URI}/root`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get all files :", error);
    throw error;
  }
};

export const uploadFiles = async (payload, onUploadProgress, signal) => {
  const URL = `${URI}/upload`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
      signal,
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred during upload files :", error);
    throw error;
  }
};

export const renameFiles = async (payload) => {
  const { fileId, ...rest } = payload;
  const URL = `${URI}/${fileId}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during rename files :", error);
    throw error;
  }
};

export const moveFile = async (payload) => {
  const { fileId, ...rest } = payload;
  const URL = `${URI}/root/${fileId}/move`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during move file :", error);
    throw error;
  }
};

export const getLargeFiles = async (payload) => {
  const URL = `${URI}/large`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get all files :", error);
    throw error;
  }
};


export const checkFileExist = async (payload) => {
  const URL = `${URI}/checkExist`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during check file exists :", error);
    throw error;
  }
};